import React from 'react';
import { Link } from 'react-router-dom';
import { paths } from './paths';
import { EmptyState } from '../ui';

export function NotFoundPage({ standalone }: { standalone?: boolean }) {
  const content = (
    <EmptyState
      title="Page not found"
      description="The page you are looking for does not exist or has moved."
      action={<Link to={paths.projects()} className="text-sm font-semibold text-brand-700 hover:underline">Go to campaigns</Link>}
    />
  );
  return standalone ? <main className="grid min-h-screen place-items-center bg-canvas">{content}</main> : content;
}
